import Axios from "axios";


const fetcher = async ({ queryKey }) => {
    const [key, { page, perPage, filterStr }] = queryKey;

    let api_url = `/api/v1/${key}`;
    api_url += "?"
    console.log(typeof page, page)
    if (!!page) api_url += `?page=${page}`;
    if (!!perPage) api_url += `&per_page=${perPage}`
    if (!!filterStr) api_url += filterStr

    const response = await Axios.get(
        `/api/v1/${key}?page=${page}&per_page=${perPage}${filterStr}`
    );
    return response.data;
}

const fetcherPickups = async ({ queryKey }) => {
    const [key, values] = queryKey;

    let api_url = `/pickups/${key}`;
    if (values && !!values.record_id) api_url += `/${values.record_id}`
    api_url += "?"
    if (values && !!values.page) api_url += `&page=${values.page}`;
    if (values && !!values.perPage) api_url += `&per_page=${values.perPage}`
    if (values && !!values.store_code) api_url += `&store_code=${values.store_code}`
    if (values && !!values.filterStr) api_url += values.filterStr
    const response = await Axios.get(
        api_url
    );
    return response.data;
};

export { fetcher, fetcherPickups }